import ReactGA from 'react-ga4';

const trackingId = 'G-4L9B21KL3T'; // Your GA4 Measurement ID
ReactGA.initialize(trackingId);

export const trackPageView = (page) => {
    console.log("page*****************", page)
    ReactGA.send({ hitType: 'pageview', page });
};
